import { lazy } from "react";

const MarketingListPage = lazy(() => import("./main"));
const CreateMarketingPage = lazy(() => import("./create"));
const UpdateMarketingPage = lazy(() => import("./update"));
const CodePage = lazy(() => import("./code"));

export {
  MarketingListPage,
  CreateMarketingPage,
  CodePage,
  UpdateMarketingPage,
};
